const STORAGE_KEY = "yavola.pendingBookingContext";

const getSessionStorage = () => {
  if (typeof window === "undefined" || !window.sessionStorage) {
    return null;
  }

  return window.sessionStorage;
};

const sanitizeObject = (value) => {
  if (value && typeof value === "object" && !Array.isArray(value)) {
    return value;
  }

  return {};
};

export const storePendingBookingContext = ({
  pendingBookingId,
  booking = {},
  availability = {},
} = {}) => {
  const storage = getSessionStorage();

  if (!storage) {
    return;
  }

  const normalizedPendingId =
    typeof pendingBookingId === "string" ? pendingBookingId.trim() : "";

  if (!normalizedPendingId) {
    return;
  }

  try {
    const payload = {
      pendingBookingId: normalizedPendingId,
      booking: sanitizeObject(booking),
      availability: sanitizeObject(availability),
      storedAt: new Date().toISOString(),
    };

    storage.setItem(STORAGE_KEY, JSON.stringify(payload));
  } catch (error) {
    console.error("Failed to store pending booking context", error);
  }
};

export const readPendingBookingContext = () => {
  const storage = getSessionStorage();

  if (!storage) {
    return null;
  }

  try {
    const raw = storage.getItem(STORAGE_KEY);

    if (!raw) {
      return null;
    }

    const parsed = JSON.parse(raw);

    if (!parsed || typeof parsed !== "object") {
      return null;
    }

    const pendingBookingId =
      typeof parsed.pendingBookingId === "string"
        ? parsed.pendingBookingId.trim()
        : "";

    if (!pendingBookingId) {
      return null;
    }

    return {
      pendingBookingId,
      booking: sanitizeObject(parsed.booking),
      availability: sanitizeObject(parsed.availability),
      storedAt: parsed.storedAt || null,
    };
  } catch (error) {
    console.error("Failed to read pending booking context", error);
    return null;
  }
};

export const clearPendingBookingContext = () => {
  const storage = getSessionStorage();

  if (!storage) {
    return;
  }

  try {
    storage.removeItem(STORAGE_KEY);
  } catch (error) {
    console.error("Failed to clear pending booking context", error);
  }
};
